(function () {
    'use strict';
    $(document).ready(function () {

        const swiperHome = new Swiper('.swiper-home', {
            //loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            speed: 1000,
        });

        const swiperActivities = new Swiper('.swiper-activities', {
            //loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'fade',
            slidesPerView: 1,
            speed: 1000,
        });

        function randomInt(min, max) {
        	return min + Math.floor((max - min) * Math.random());
        }

        setInterval(function() {
            $('.section-decors div, .animated-elements').each(function() {
                var left = randomInt(25, 100) + 'px';
                var top = randomInt(25, 100) + 'px';
                $(this).css({
                    'transform': 'translate(' + left + ', ' + top + ')',
                });
            });
        }, 3000);

    });
}(jQuery));
